import React from 'react';
import { useNavigate } from 'react-router-dom';

const SuccessScreen = ({ applicationData }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-lg mx-auto text-center py-8">
      {/* Success Animation */}
      <div className="relative inline-block mb-8">
        <div
          className="w-24 h-24 rounded-full flex items-center justify-center text-4xl mx-auto shadow-2xl"
          style={{ background: 'linear-gradient(135deg, #ffd700, #f59e0b)' }}
        >
          🎉
        </div>
        <div
          className="absolute -top-2 -right-2 w-8 h-8 rounded-full flex items-center justify-center text-sm"
          style={{ background: '#0a1628', color: '#ffd700' }}
        >
          ✓
        </div>
      </div>
      <h2 className="text-3xl font-bold mb-3" style={{ color: '#0a1628' }}>
        Application Submitted!
      </h2>
      <p className="text-gray-500 mb-8 leading-relaxed">
        Welcome to the OnTheGo driver family, <strong>{applicationData?.fullName?.split(' ')?.[0] || 'Driver'}</strong>!
        Your application has been received and is under review.
      </p>
      {/* Reference Number */}
      <div
        className="rounded-2xl p-5 mb-6 text-left"
        style={{ background: 'linear-gradient(135deg, #0a1628, #1a2d4a)' }}
      >
        <p className="text-xs mb-1" style={{ color: 'rgba(255,215,0,0.7)' }}>
          Application Reference
        </p>
        <p className="font-mono font-bold text-lg" style={{ color: '#ffd700' }}>
          OTG-DRV-{Date.now()?.toString()?.slice(-8)}
        </p>
        <p className="text-xs mt-2" style={{ color: 'rgba(255,255,255,0.5)' }}>
          Save this reference number for tracking your application status
        </p>
      </div>
      {/* Next Steps */}
      <div className="text-left mb-8">
        <h3 className="font-bold text-sm mb-4" style={{ color: '#0a1628' }}>
          What Happens Next
        </h3>
        <div className="space-y-3">
          {[
            {
              step: '1',
              title: 'Document Review',
              desc: 'Our team reviews your uploaded documents',
              time: '1-2 business days',
            },
            {
              step: '2',
              title: 'Background Check',
              desc: 'Background verification is completed',
              time: '2-3 business days',
            },
            {
              step: '3',
              title: 'Approval & Activation',
              desc: 'Your account is activated and you receive your driver kit',
              time: '1 business day',
            },
          ]?.map((item) => (
            <div key={item?.step} className="flex items-start gap-4">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0"
                style={{ background: 'rgba(255,215,0,0.15)', color: '#f59e0b' }}
              >
                {item?.step}
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <p className="font-semibold text-sm" style={{ color: '#0a1628' }}>
                    {item?.title}
                  </p>
                  <span
                    className="text-xs px-2 py-0.5 rounded-full"
                    style={{ background: '#f3f4f6', color: '#6b7280' }}
                  >
                    {item?.time}
                  </span>
                </div>
                <p className="text-xs text-gray-400 mt-0.5">{item?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Total Timeline */}
      <div
        className="rounded-xl p-4 mb-8 flex items-center gap-3"
        style={{ background: 'rgba(255,215,0,0.08)', border: '1px solid rgba(255,215,0,0.3)' }}
      >
        <span className="text-2xl">⏱️</span>
        <div className="text-left">
          <p className="font-bold text-sm" style={{ color: '#0a1628' }}>
            Estimated Approval: 3-6 Business Days
          </p>
          <p className="text-xs text-gray-500">
            You'll receive an SMS and email notification at {applicationData?.phone || 'your registered number'}
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <button
          onClick={() => navigate('/driver-dashboard-screen')}
          className="w-full py-3.5 rounded-xl font-bold text-sm transition-all duration-200 hover:opacity-90 active:scale-95 shadow-lg"
          style={{ background: 'linear-gradient(135deg, #ffd700, #f59e0b)', color: '#0a1628' }}
        >
          Go to Driver Dashboard
        </button>
        <button
          onClick={() => navigate('/')}
          className="w-full py-3.5 rounded-xl font-bold text-sm border-2 transition-all duration-200 hover:bg-gray-50"
          style={{ borderColor: '#0a1628', color: '#0a1628' }}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default SuccessScreen;
